import { v4 } from 'uuid';

const uuid = crypto.randomUUID?.() || v4();
let toastElement: Element;

const createToastElement = () => {
  const element = document.createElement('div');
  element.className = 'web3-wc-toast hidden';
  element.id = uuid;
  document.body.appendChild(element);
  toastElement = document.getElementById(uuid);
  toastElement.addEventListener('click', () => {
    toastElement.className = 'web3-wc-toast hidden';
  });
  return toastElement;
};

const getToastElement = () => {
  if (toastElement) {
    return toastElement;
  }
  toastElement = document.getElementById(uuid);
  if (toastElement) {
    return toastElement;
  }
  return createToastElement();
};

export const showToast = (text: string, timeout: number = 3 * 1000) => {
  const toast = getToastElement();
  toast.innerHTML = text;
  toast.className = 'web3-wc-toast visible';
  const t = setTimeout(() => {
    clearTimeout(t);
    toast.className = 'web3-wc-toast hidden';
  }, timeout);
};

declare const window: any;

window.toast = showToast;